export default "__VITE_ASSET__BqqB6SWp__"